import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

const teamMembers = [
  {
    avatar: <Avatar alt="Cristian S" src="/static/images/avatar/1.jpg" />,
    name: 'Cristian S.',
    occupation: 'Software Engineer',
    route:"/chris",
    mainSkill: 'sys',
    nationality:'https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fflags%2FFlag_of_Mexico.svg?alt=media&token=a51a46f7-1c2b-4872-84d0-7c86dcc756bb',
    testimonial:
      "I’m constantly developing software. "+
      "Usually I´m a multiple programming languages, AI and design tools for create fantastic software systems."+
      "In my last job I was working for big e-commerce systems for brands big brands in the region of Latin America."
  },
  {
    avatar: <Avatar alt="Emmanuel C." src="/static/images/avatar/2.jpg" />,
    name: 'Emmanuel V.',
    occupation: 'Software Developer',
    mainSkill: 'React',
    route:"/emmanuel",
    nationality:'https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fflags%2FFlag_of_Mexico.svg?alt=media&token=a51a46f7-1c2b-4872-84d0-7c86dcc756bb',
    testimonial:
      "Being passionate and eager to contribute using my experience "+
      "and knowledge, I have 3 years of experience working as a"+
      "freelancer and 2 working professionally. "+
      "I am committed to following the best coding practices to"+
      "produce and deliver maintainable and readable code, as well"+
      "as following Figma designs to the letter to deliver to end users"+
      "delightful experiences.",
  },
  {
    avatar: <Avatar alt="José L." src="/static/images/avatar/3.jpg" />,
    name: 'José L.',
    occupation: 'DevOps Engineer',
    mainSkill: 'K8s',
    route:"/sevilla",
    nationality:'https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fflags%2FFlag_of_Mexico.svg?alt=media&token=a51a46f7-1c2b-4872-84d0-7c86dcc756bb',
    testimonial:
      "SRE specialized in Linux, high availability and infrastructure monitoring. " +
      "RELIABILITY, SCALABILITY and SECURITY are my focus. " +
      "Load balancing, DNS, firewalls, optimization slow queries and automation. " +  
      "Cloud & On promise: GCP, AWS, Kubernetes and Docker Swarm. " + 
      "SQL (PostgreSQL, MySQL, SQL Server) and NoSQL (MongoDB, Firebase) management. "
  },
  {
    avatar: <Avatar alt="Israel E." src="/static/images/avatar/3.jpg" />,
    name: 'Israel E.',
    occupation: 'Audiovisual Production',
    mainSkill: "D.C.",
    route:"/israel",
    nationality:'https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fflags%2FFlag_of_Mexico.svg?alt=media&token=a51a46f7-1c2b-4872-84d0-7c86dcc756bb',
    testimonial:
      "Professional in visual and audiovisual production with experience in creative direction, content development, "+
     "and narrative design applied to digital environments. He has collaborated on projects that integrate image, structure, "+
     "and technology to create functional and visually coherent solutions. Experience includes campaigns, product content, corporate videos, and applied storytelling."
  },
];
export default function Team() {
  const navigate = useNavigate();

  React.useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  
  const handleOpenProfile = (index)=>{  
    const route = teamMembers[index].route
    navigate(route)
  }


  return (
    <Container
      id="testimonials"
       maxWidth={false}
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Stack
        spacing={2}
        sx={{
          width: { sm: '100%', md: '60%' },
          textAlign: 'center', // centers text
          mx: 'auto',          // centers the whole stack if needed
        }}
        justify="center"
      >
        <Typography component="h1" variant="h1" color="#ffffffff">
          Team Leidenfrost
        </Typography>

        <Typography variant="subtitle1" color="#ffffffff">
          At Leidenfrost, we are a dynamic and talented group of developers, 
          designers, and innovators committed to bringing your ideas to life. 
          With years of collective experience and a passion for pushing the boundaries of technology, 
          we specialize in crafting bespoke solutions that drive success and transform industries.
        </Typography>
      </Stack>
      <Grid 
          container 
          spacing={2} 
          sx={{ width: { xs: '100%', sm:'100%', md: '75%', lg:'50%', xl:'50%'} }}
      >
        {teamMembers.map((testimonial, index) => (
          <Grid item xs={12} sm={6} key={index} sx={{ display: "flex" }}>
            <Card
              sx={{
                flexGrow: 1,
                p: 2,
                
                transform: index  === 0 ? "rotate(2deg)" : index === 3 ? "rotate(5deg)" : "rotate(-2deg)",
                transformOrigin: index % 2 === 0 ? "left top" : "right top",
                transition: "transform 0.3s ease",
                "&:hover": {
                  transform: index % 2 === 0 ? "rotate(0deg) scale(1.02)" : "rotate(0deg) scale(1.02)",
                },
              }}
              onClick={() => handleOpenProfile(index)}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  pr: 2,
                }}
              >
                <CardHeader
                  avatar={testimonial.avatar}
                  title={testimonial.name}
                  subheader={testimonial.occupation}
                  titleTypographyProps={{
                    sx: {
                      color: "white",   // 🎨 main theme color
                      fontWeight: "bolder",
                    },
                  }}
                  subheaderTypographyProps={{
                    sx: {
                      color: "white", // 🎨 softer gray
                      fontStyle: "italic",
                    },
                  }}
                />
                <Box
                  component="img"
                  src={testimonial.nationality}
                  sx={{
                    width: 56,
                    height: 32,
                    alignSelf: "center",
                  }}
                />
              </Box>
              <CardContent>
                <Typography
                  variant="body2"
                  color="#fff"
                  sx={{ wordBreak: "break-word" }}
                >
                  {testimonial.testimonial}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
